import { useMutation, useQueryClient } from "@tanstack/react-query"

import { ContentService, type SubjectMergeRequest } from "@/client"

export function useSubjectMerge() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: SubjectMergeRequest) =>
      ContentService.mergeSubjects({ requestBody: payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["subjects"] })
    },
  })
}
